import React, { Suspense } from 'react';
import { Routes, Route, Navigate} from 'react-router-dom';

import { 
  authContextHelper,
  helpers,
  types
} from 'utilities';

import EnsureConfigLoaded from '../../pages/auth/EnsureConfigLoaded';


// lazy load pages
const Home = React.lazy(() => import('../pages/home/Home'));
const Enabled = React.lazy(() => import('../pages/auth/Enabled'));
const Authenticate = React.lazy(() => import('../pages/auth/Authenticate'));
const ProductWindow = React.lazy(() => import('../pages/product/ProductWindow'));

const loading = () => <div className=""></div>;


const SuspenseLoader = ({ component: Component, setShowTopSearchBar }: types.IntSuspenseLoader & {setShowTopSearchBar?: any}) => {
  return (
    <Suspense fallback={loading()}>
      <Component setShowTopSearchBar={setShowTopSearchBar} />
    </Suspense>
  )
};

const MobileRouteDefinitions: React.FC<types.IntMobileRouteDefinitions> = ({ setShowTopSearchBar, mobileEnabled }) => (
  helpers.logToOutput('!! MobileRouteDefinitions.tsx: MobileRouteDefinitions component loading: mobileEnabled:', mobileEnabled),
  <Routes>
    {mobileEnabled ? (
      <>
        <Route path="/authenticate" element={
          <SuspenseLoader component={Authenticate} setShowTopSearchBar={setShowTopSearchBar} />
        } 
        />

        <Route 
          path="/" 
          element={
            <authContextHelper.EnsureSignedIn>
              <EnsureConfigLoaded>
                <SuspenseLoader component={Home} setShowTopSearchBar={setShowTopSearchBar}/>
              </EnsureConfigLoaded>
            </authContextHelper.EnsureSignedIn>
          }
        />

        <Route 
          path="/product-window" 
          element={
            <authContextHelper.EnsureSignedIn>
              <EnsureConfigLoaded>
                <SuspenseLoader component={ProductWindow} setShowTopSearchBar={setShowTopSearchBar} />
              </EnsureConfigLoaded>
            </authContextHelper.EnsureSignedIn>
          } 
        />

        <Route path="/*" element={<Navigate to="/authenticate" replace />}/>
      </>
    ) : (
      <>
        <Route path="/*" element={
          <SuspenseLoader component={Enabled} setShowTopSearchBar={setShowTopSearchBar} />
        } 
        />
      </>
    )}
  </Routes>      
);

export default MobileRouteDefinitions;